
export const CHECKED_CHECKLIST = `CHECK_CHECKLIST`;
export const UNCHECKED_CHECKLIST = `UNCHECK_CHECKLIST`;
export const ONLOAD_CHECKLIST = `ONLOAD_CHECKLIST`;

